<template>
    <div class="block">

      <h4 class="title is-6">Documents / Labels</h4>
      <span>
        Accuracy: {{  this.accuracy }}
        <br>
        rows: {{  this.rows }}, predictions: {{  this.predictions  }}
        <br>
      <b-progress type="is-primary" size="is-small" format="percent" :max="projectDocuments.length" :value="projectDocuments.filter( item => item.label != false).length" show-value>
         {{ projectDocuments.filter( item => item.label == item.model_prediction).length }} / All: {{ projectDocuments.filter( item => item.label != false).length }} / {{ projectDocuments.length }} ({{ (projectDocuments.filter( item => item.label != false).length / projectDocuments.length*100).toFixed(0) }}%)
      </b-progress>

      <b-progress type="is-primary" size="is-small" v-for="label in project.labels" :max="1" :value="projectDocuments.filter( item => item.label == label.label).length / projectDocuments.length" show-value>
            {{ label.label }}: {{ projectDocuments.filter( item => item.label == label.label).length }} ({{ (projectDocuments.filter( item => item.label == label.label).length / projectDocuments.length*100).toFixed(0) }}%)
      </b-progress>
      </span>
  </div>
</template>
<script>
import { throws } from 'assert';

    
    export default {
    props: ["projectId","project","projectDocuments"],
    name: "ProjectStatistics",
      components: {  },
      data() {
        return {
            accuracy: null,
            rows: 0,
            labeled: 0,
            unlabeled: 0,
            predictions: 0,
            labels: {}
        };
      },
      created() {
        // this.$store.dispatch("currentProjectDocuments", this.projectId);

        this.rows = this.projectDocuments.length 
        this.labeled = this.projectDocuments.filter( item => item.label != false).length 
        this.unlabeled = this.projectDocuments.filter( item => item.label == false).length 
        this.predictions = this.projectDocuments.filter( item => item.model_prediction != false).length 
        if (this.predictions > 0){
          this.accuracy = this.projectDocuments.filter( item => item.label == item.model_prediction).length 
        }
      },
      computed: {
        // projectDocuments(){
        //     return this.$store.state[`documents-${this.projectId}`]
        // },
      }
        
    }
    </script>